import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import GuideArticle from '@/pages/article/guide-2026/page';
import KakobuyArticle from '@/pages/article/kakobuy/page';
import CSSBuyArticle from '@/pages/article/cssbuy/page';
import SuperbuyArticle from '@/pages/article/superbuy/page';
import ComparisonPage from '@/pages/article/comparison/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/best-hipobuy-spreadsheet-guide-2026/',
    element: <GuideArticle />,
  },
  {
    path: '/kakobuy-spreadsheet-guide/',
    element: <KakobuyArticle />,
  },
  {
    path: '/cssbuy-spreadsheet-guide/',
    element: <CSSBuyArticle />,
  },
  {
    path: '/superbuy-spreadsheet-guide/',
    element: <SuperbuyArticle />,
  },
  {
    path: '/spreadsheet-comparison/',
    element: <ComparisonPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;